// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'target-path';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M15.188 9.162a3.96 3.96 0 0 0 1.364-1.069m.865-2.125a3.977 3.977 0 0 0-.225-1.718m-1.389-1.829a3.826 3.826 0 0 0-1.593-.681M2.732 9.97a3.864 3.864 0 0 0-1.39 1.168m-.778 2.274a3.86 3.86 0 0 0 .387 1.773m1.65 1.749a3.946 3.946 0 0 0 1.751.479M8.435 6.172v11.25M6.288 8.32l2.147-2.148 2.148 2.148M6.748 2.234a1.687 1.687 0 1 0 3.375 0 1.687 1.687 0 0 0-3.375 0z'
  />
);

export const viewBox = '0 0 18 18';
